let FETCH_CEP = false;

function postCodeHandler() {
    const wrapper = document.querySelector('.calculo-frete');
    if (wrapper == null) return;
    const cepResultado = wrapper.querySelector('.cep-resultado');
    const form = wrapper.querySelector('.frete-form');
    const freteResultado = wrapper.querySelector('.frete-resultado');
    if (form == null || cepResultado == null || freteResultado == null) return;
    const input = form.querySelector('input[name="cep"]');
    const button = form.querySelector('button');
    if (input == null || button == null) return;

    const setError = () => {
        freteResultado.style.display = 'none';
        cepResultado.style.display = 'block';
        cepResultado.innerHTML = '<span class="cep-error">CEP Inv\xE1lido.</span>'
    };

    button.addEventListener('click', () => {
        if (FETCH_CEP) return;
        button.classList.add('disabled');
        button.disabled = input.disabled = FETCH_CEP = true;
        fetch(`https://viacep.com.br/ws/${input.value.trim()}/json/`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                if (data.cep) {
                    input.value = data.cep;
                    cepResultado.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="16" height="16" x="0" y="0" viewBox="0 0 512 512"><g><path d="M256 0C153.755 0 70.573 83.182 70.573 185.426c0 126.888 165.939 313.167 173.004 321.035 6.636 7.391 18.222 7.378 24.846 0 7.065-7.868 173.004-194.147 173.004-321.035C441.425 83.182 358.244 0 256 0zm0 278.719c-51.442 0-93.292-41.851-93.292-93.293S204.559 92.134 256 92.134s93.291 41.851 93.291 93.293-41.85 93.292-93.291 93.292z" fill="var(--arw)"></path></g></svg> <span style="font-weight: 600;color:var(--arw);">${data.logradouro} - ${data.localidade}/${data.uf}</span>`;
                    cepResultado.style.display = 'block';
                    freteResultado.style.display = 'block';
                } else setError();
            })
            .catch(() => setError()).finally(() => {
                button.disabled = input.disabled = FETCH_CEP = false;
                button.classList.remove('disabled');
            });
    });
}

document.addEventListener('DOMContentLoaded', () => postCodeHandler());